import { render, staticRenderFns } from "./emptyRouterComponent.vue?vue&type=template&id=0815746c&scoped=true&lang=pug"
import script from "./emptyRouterComponent.vue?vue&type=script&lang=js"
export * from "./emptyRouterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0815746c",
  null
  
)

export default component.exports